<template>
    <q-page class="fit">
        <p class="q-display-1">
            Bieguny <refresh-component observe="pole"/>
        </p>

        <div class="text-center" v-if="$store.state.RS.pole === 'fetch_ongoing'">
            <q-icon name="cached"
                    style="font-size: 1.5rem" dense
                    class="animate-spin items-center"/>
        </div>
        <template v-else-if="$store.state.RS.pole === 'fetch_failed'">
            <div>Nie udało się pobrac biegunów.
                <a href="#" @click.prevent="fetch">Spróbuj ponownie.</a>
            </div>
        </template>
        <template v-else-if="$store.state.RS.pole === 'fetch_done'">
            <template>
                <p class="text-bold text-center q-pa-sm q-ma-md" style="background-color: rgba(0,0,0,0.1)">
                    <span>Bazowe</span>

                    <q-btn
                        round
                        icon="add"
                        color="green"
                        size="xs"
                        v-if="! $store.getters.basePole"
                        :to="{name: 'pole-add', params: {group: 'junior', phase: 2}}">
                        <q-tooltip anchor="top left">
                            Dodaj biegun bazowy
                        </q-tooltip>
                    </q-btn>

                    <a
                        v-if="hasRemovedBasePoles"
                        href="#" class="showRemovedToggle"
                        @click.prevent="showRemovedBasePoles = !showRemovedBasePoles">
                        <template v-if="showRemovedBasePoles">
                            Ukryj usunięte
                        </template>
                        <template v-else>
                            Pokaż usunięte
                        </template>
                    </a>
                </p>

                <div class="poles">
                    <PoleComponent
                        v-for="pole in base"
                        :key="pole.poleId"
                        :model="pole"
                        :editable="true"
                        :inline="true"
                        :isBasePole="pole.poleId === $store.state.BASE_POLE_ID"/>
                </div>

                <p class="text-bold text-center q-pa-sm q-ma-md" style="background-color: rgba(0,0,0,0.1)">
                    <span>Dla anonimowych</span>

                    <q-btn
                        round
                        icon="add"
                        color="green"
                        size="xs"
                        :to="{name: 'pole-add', params: {group: 'junior', phase: 0}}">
                        <q-tooltip anchor="top left">
                            Dodaj biegun dla juniora
                        </q-tooltip>
                    </q-btn>

                    <q-btn
                        round
                        icon="add"
                        color="orange"
                        size="xs"
                        :to="{name: 'pole-add', params: {group: 'senior', phase: 0}}">
                        <q-tooltip anchor="top left">
                            Dodaj biegun dla seniora
                        </q-tooltip>
                    </q-btn>

                    <a
                        v-if="hasRemovedZeroPoles"
                        href="#"
                        class="showRemovedToggle"
                        @click.prevent="showRemovedZeroPoles = !showRemovedZeroPoles">
                        <template v-if="showRemovedZeroPoles">
                            Ukryj usunięte
                        </template>
                        <template v-else>
                            Pokaż usunięte
                        </template>
                    </a>
                </p>

                <div class="poles">
                    <PoleComponent
                        v-for="pole in zero"
                        :key="pole.poleId"
                        :model="pole"
                        :editable="true"
                        :inline="true"
                        :isBasePole="pole.poleId === $store.state.BASE_POLE_ID"/>
                </div>



                <p class="text-bold text-center q-pa-sm q-ma-md" style="background-color: rgba(0,0,0,0.1)">Kwalifikacyjne
                    <q-btn
                        round
                        icon="add"
                        color="green"
                        size="xs"
                        :to="{name: 'pole-add', params: {group: 'junior', phase: 1}}">
                        <q-tooltip anchor="top left">
                            Dodaj biegun dla juniora
                        </q-tooltip>
                    </q-btn>

                    <q-btn
                        round
                        icon="add"
                        color="orange"
                        size="xs"
                        :to="{name: 'pole-add', params: {group: 'senior', phase: 1}}">
                        <q-tooltip anchor="top left">
                            Dodaj biegun dla seniora
                        </q-tooltip>
                    </q-btn>

                    <a
                        v-if="hasRemovedQualifyingPoles"
                        href="#"
                        class="showRemovedToggle"
                        @click.prevent="showRemovedQualifyingPoles = !showRemovedQualifyingPoles">
                        <template v-if="showRemovedQualifyingPoles">
                            Ukryj usunięte
                        </template>
                        <template v-else>
                            Pokaż usunięte
                        </template>
                    </a>
                </p>

                <div class="poles">
                    <PoleComponent
                        v-for="pole in qualifying"
                        :key="pole.poleId"
                        :model="pole"
                        :editable="true"
                        :inline="true"
                        :isBasePole="pole.poleId === $store.state.BASE_POLE_ID"/>
                </div>


                <p class="text-bold text-center q-pa-sm q-ma-md" style="background-color: rgba(0,0,0,0.1)">Tematyczne
                    <q-btn
                        round
                        icon="add"
                        color="green"
                        size="xs"
                        :to="{name: 'pole-add', params: {group: 'junior', phase: 2}}">
                        <q-tooltip anchor="top left">
                            Dodaj biegun dla juniora
                        </q-tooltip>
                    </q-btn>

                    <q-btn
                        round
                        icon="add"
                        color="orange"
                        size="xs"
                        :to="{name: 'pole-add', params: {group: 'senior', phase: 2}}">
                        <q-tooltip anchor="top left">
                            Dodaj biegun dla seniora
                        </q-tooltip>
                    </q-btn>

                    <a
                        v-if="hasRemovedRegularPoles"
                        href="#"
                        class="showRemovedToggle"
                        @click.prevent="showRemovedRegularPoles = !showRemovedRegularPoles">
                        <template v-if="showRemovedRegularPoles">
                            Ukryj usunięte
                        </template>
                        <template v-else>
                            Pokaż usunięte
                        </template>
                    </a>
                </p>

                <div class="poles">
                    <PoleComponent
                        v-for="pole in regular"
                        :key="pole.poleId"
                        :model="pole"
                        :editable="true"
                        :inline="true"
                        :isBasePole="pole.poleId === $store.state.BASE_POLE_ID"/>
                </div>


            </template>
        </template>

    </q-page>
</template>
<script>
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import PoleComponent from './pole/PoleComponent'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import FixedButtons from './FixedButtons'
    import QLayout from 'quasar-framework/src/components/layout/QLayout'
    import RefreshComponent from './RefreshComponent'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'

    export default {
        name: 'Poles',
        components: {QBtn, RefreshComponent, QLayout, FixedButtons, QTooltip, PoleComponent, QIcon},
        mounted () {
            // this.fetch()
        },
        methods: {
            fetch () {
                this.$store.dispatch('fetchAll', {
                    what: 'pole'
                })
            },
        },
        data () {
            return {
                showRemovedBasePoles: false,
                showRemovedZeroPoles: false,
                showRemovedQualifyingPoles: false,
                showRemovedRegularPoles: false,
            }
        },
        computed: {
            poles () {
                const pp = [...this.$store.state.pole]

                pp.sort(({
                     publicationInformation: pubA,
                     group: groupA,
                     category: categoryA
                }, {
                    publicationInformation: pubB,
                    group: groupB,
                    category: categoryB
                }) => {
                    if (groupA !== groupB) {
                        return groupA < groupB ? -1 : 1;
                    }

                    if (categoryA !== categoryB) {
                        return categoryA < categoryB ? -1 : 0;
                    }

                    if (pubA && pubB) {
                        return new Date(pubB.publishTs) - new Date(pubA.publishTs);
                    } else if (!pubA && pubB) {
                        1;
                    } else if (pubA && !pubB) {
                        return -1
                    }
                    return 0;
                })

                return pp
            },
            base () {
                return this.poles.filter(p => {
                    return p.poleId === this.$store.state.BASE_POLE_ID
                        && (!p.deleted || this.showRemovedBasePoles)
                })
            },
            zero () {
                return this.poles.filter(p => {
                    return p.phase === 0
                        && (!p.deleted || this.showRemovedZeroPoles)
                })
            },
            qualifying () {
                return this.poles.filter(p => {
                    return p.phase === 1
                        && (!p.deleted || this.showRemovedQualifyingPoles)
                })
            },
            regular () {
                return this.poles.filter(p => {
                    return p.phase === 2 && p.poleId !== this.$store.state.BASE_POLE_ID
                        && (!p.deleted || this.showRemovedRegularPoles)
                })
            },
            hasRemovedBasePoles () {
                return this.poles.filter(p => p.poleId === this.$store.state.BASE_POLE_ID && p.deleted).length > 0;
            },
            hasRemovedZeroPoles () {
                return this.poles.filter(p => p.phase === 0 && p.deleted).length > 0
            },
            hasRemovedQualifyingPoles () {
                return this.poles.filter(p => p.phase === 1 && p.deleted).length > 0
            },
            hasRemovedRegularPoles () {
                return this.poles.filter(p => p.phase === 2 && p.poleId !== this.$store.state.BASE_POLE_ID && p.deleted).length > 0
            }
        },
    }
</script>

<style lang="scss" scoped>
    .showRemovedToggle {
        float: right;
    }
</style>